import React, { useEffect, useState } from 'react'
import MainLayout from '../../containers/MainLayout'
import Loader from '../../baseComponents/Loader'
import PageTitle from '../../baseComponents/PageTitle'
import AnimalHealth from './components/AnimalHealth'
import Prescription from './components/Prescription'
import ProductList from './components/Products'
// import { Redirect } from 'react-router-dom'

import { connect } from 'react-redux'
import { getProductInfo } from '../../services/products'
import { langTexts } from './locals'
import { getURLByRouteName } from '../../utils/routes'

import titleLogo from '../../assets/images/title-icons/Apps-Line.svg'
import { ReactComponent as Logo } from '../../assets/images/title-icons/Apps-Line.svg'


import './index.css'

const Products = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]
    , [activeClass, setActiveClass] = useState('')
    , [touched, setTouched] = useState(false)

  let [data, setData] = useState(null)
    , [isFetching, setIsFetching] = useState(true)
    , [selector, setSelector] = useState(props.match.params)
    , { id } = props.match.params

  const onSetPage = url => {
    setActiveClass('')
    setTouched(true)
    setTimeout(() => {
      props.history.push(url)
    }, 1200)
  }

  const getSection = () => {
    if (!data) return null
    let section = data[lang]
    switch (selector) {
      case 'libre-venta': return <ProductList texts={texts} {...section} lang={lang} /> // <Redirect to={getURLByRouteName('construction')} />
      case 'prescripcion': return <Prescription {...section} />
      case 'salud-animal': return <AnimalHealth {...section} />
      default: return null
    }
  }

  useEffect(() => {
    let timeout = null
    if (id !== selector) {
      setSelector(id)
      setActiveClass('')
      if (touched) {
        setActiveClass('active')
      }
    }
    getProductInfo()
      .then(res => {
        setData(res)
        setIsFetching(false)
        timeout = setTimeout(() => {
          setActiveClass('active')
        }, 1000)
      })
      .catch(err => console.log(err))
    return () => {
      clearTimeout(timeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  if (isFetching) return <Loader />

  let info = data[lang]
    , title = info.title ? info.title : texts.title
    , label = info.titleRedLabel ? info.titleRedLabel : ''

  return <MainLayout id='products' className={`${activeClass}`} logo={<Logo />}>
    <PageTitle title={title} label={label} logo={titleLogo} />
    <div className='products__container'>
      <div>
        <div className='products__gray-line-container'>
          <div className='gray-line' />
          <img src={titleLogo} className='title-logo' alt='page icon' />
        </div>
      </div>
      <div className='products__info-section'>
        <div className='products__selector transition'>
          <div className={`products__selector-item ${id === 'libre-venta' ? 'active' : ''}`}>
            <p onClick={() => onSetPage(getURLByRouteName('freeSale'))}>{texts['libre-venta']}</p>
          </div>
          <div className={`products__selector-item ${id === 'prescripcion' ? 'active' : ''}`}>
            <p onClick={() => onSetPage(getURLByRouteName('prescription'))}>{texts['prescripcion']}</p>
          </div>
          <div className={`products__selector-item ${id === 'salud-animal' ? 'active' : ''}`}>
            <p onClick={() => onSetPage(getURLByRouteName('animalHealth'))}>{texts['salud-animal']}</p>
          </div>
        </div>
        <div className='products__content'>
          {getSection()}
        </div>
      </div>
    </div>

  </MainLayout>
}

const mapStateToProps = state => ({
  settings: state.settings,
})

export default connect(mapStateToProps)(Products)